import { render } from "./real-investors.vue?vue&type=template&id=04be6c21"
import script from "./real-investors.vue?vue&type=script&lang=js"
export * from "./real-investors.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__